var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.transcript.uiState.timeSpanSelection.start !== null &&
    _vm.transcript.uiState.timeSpanSelection.end !== null)?_c('div',{staticClass:"selection",style:({
    left: _vm.getSelectionLeft() * _vm.settings.pixelsPerSecond + 'px',
    width: _vm.getSelectionLength() * _vm.settings.pixelsPerSecond + 'px'
  })},[_c('div',{staticClass:"selection-length"},[_vm._v(" "+_vm._s(_vm.getSelectionLength().toFixed(2))+" sec ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }